import { render, staticRenderFns } from "./order_detial.vue?vue&type=template&id=e022a18e&scoped=true"
import script from "./order_detial.vue?vue&type=script&lang=js"
export * from "./order_detial.vue?vue&type=script&lang=js"
import style0 from "./order_detial.vue?vue&type=style&index=0&id=e022a18e&prod&scoped=true&lang=less"
import style1 from "./order_detial.vue?vue&type=style&index=1&id=e022a18e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e022a18e",
  null
  
)

export default component.exports